module.exports = __webpack_public_path__ + "static/img/200210.64b5c3dd.png";